// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_pm-0";
export var buttonContainer = "_pm-3";
export var cancelButton = "_pm-4";
export var headerSection = "_pm-6";
export var headerTitle = "_pm-9";
export var messageSideLeft = "_pm-1";
export var messageSideRight = "_pm-2";
export var orderNumberContainer = "_pm-7";
export var orderNumberLabel = "_pm-8";
export var submitButton = "_pm-5";